import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import {
  ApiDataResponse,
  AssignAssigneeRoleRequest,
  AuthorizationAssignee,
} from "../types";

const assignAssigneeRole = async ({
  token,
  userId,
  ...payload
}: AssignAssigneeRoleRequest): Promise<ApiDataResponse<AuthorizationAssignee>> => {
  const response = await axios.put<ApiDataResponse<AuthorizationAssignee>>(
    `${END_POINT.BASE_URL}/v1/administrator/authorization/assignees/${userId}/role`,
    payload,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const useAssignAssigneeRole = () => {
  return useMutation(assignAssigneeRole);
};
